{
  "en": {
    "notification": {
      "actions": {
        "delete": "Delete notification",
        "deleteAll": "Delete all",
        "markAllAsRead": "Mark all as read",
        "mark_as_read": "Mark as read",
        "mark_as_unread": "Mark as unread"
      },
      "customers": {
        "announcement": {
          "create": "created a news post. | created {group_notification_count} news posts. |_| created {group_notification_count} news posts."
        },
        "decision": {
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "added decision <i>'{notifiable_name}'</i>."
          },
          "relaunched": "made the decision <i>'{notifiable_name}'</i> available again."
        },
        "decision_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "approved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | approved {group_notification_count} proposals in decision <i>'{group_name}'</i>. | approved {group_notification_count} proposals in decision <i>'{group_name}'</i>.",
          "create": "created proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | created {group_notification_count} proposals in decision <i>'{group_name}'</i>. | created {group_notification_count} proposals in decision <i>'{group_name}'</i>.",
          "edit_approved": "edited the approved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | edited {group_notification_count} approved proposals in decision <i>'{group_name}'</i>. | edited {group_notification_count} approved proposals in decision <i>'{group_name}'</i>.",
          "relaunched": "made the proposal <i>'{notifiable_name}'</i> that you requested changes for available again | made {group_notification_count} proposals in decision <i>'{group_name}'</i> that you requested changes for available again | made {group_notification_count} proposals in decision <i>'{group_name}'</i> that you requested changes for available again"
        },
        "document": {
          "create": "uploaded document <i>'{notifiable_name}'</i>. | uploaded {group_notification_count} documents. |_| uploaded {group_notification_count} documents.",
          "installment": {
            "create": "added invoice <i>'{notifiable_name}'</i> to an installment. | added {group_notification_count} invoices to an installment. |_| added {group_notification_count} invoices to an installment."
          },
          "invoice": {
            "create": "uploaded invoice <i>'{notifiable_name}'</i>. | uploaded {group_notification_count} invoices. |_| uploaded {group_notification_count} invoices."
          },
          "proposal": {
            "create": "added document <i>'{notifiable_name}'</i> to proposal <i>'{group_name}'</i>. | added {group_notification_count} documents to proposal <i>'{group_name}'</i>. |_| added {group_notification_count} documents to proposal <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Your export data is ready to be downloaded."
        },
        "installment": {
          "published": "made installment <i>'{notifiable_name}'</i> available.  | made {group_notification_count} installments available. | made {group_notification_count} installments available.",
          "status": {
            "changed": "changed the status of installment <i>'{notifiable_name}'</i> to <i>'{status}'</i>.  | changed the status of {group_notification_count} installments. | changed the status of {group_notification_count} installments."
          }
        },
        "issue": {
          "approval": {
            "create": "requested approval for snag <i>'{notifiable_name}'</i> | requested approval for {group_notification_count} snags. | requested approval for {group_notification_count} snags."
          },
          "create": "created snag <i>'{notifiable_name}'</i> | created {group_notification_count} snags | created {group_notification_count} snags",
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>."
          },
          "status": {
            "update": "has updated the status of <i>'{notifiable_name}'</i> to <i>'{status}'</i> | updated the status of {group_notification_count} snags. | updated the status of {group_notification_count} snags."
          }
        },
        "question": {
          "create": "created question <i>'{notifiable_name}'</i> in FAQ <i>'{group_name}'</i>. | created {group_notification_count} questions in FAQ <i>'{group_name}'</i>. |_| created {group_notification_count} questions in FAQ <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "Don't forget to make a decision for <i>'{notifiable_name}'</i>."
          },
          "installment": {
            "due": "Don't forget to make a payment for <i>'{notifiable_name}'</i>."
          }
        },
        "survey": {
          "published": "would like your feedback regarding <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "confirmation": {
            "requested": "asked you to confirm <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "asked you to upload a document for <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "started conversation <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>.",
            "move": "moved your message to conversation <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in conversation <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "created a news post. | created {group_notification_count} news posts in <i>'{group_name}'</i>. |_| created {group_notification_count} news posts in <i>'{group_name}'</i>."
        },
        "decision": {
          "mention": {
            "create": "mentioned you in conversation <i>'{group_name}'</i>. | mentioned you in {group_notification_count} messages in conversation <i>'{group_name}'</i>. |_| mentioned you in {group_notification_count} messages in conversation <i>'{group_name}'</i>."
          },
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>."
          },
          "not_interested": "is not interested in decision <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "made you the new responsible for decision <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "approved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | approved {group_notification_count} proposals in decision <i>'{group_name}'</i>. |_| approved {group_notification_count} proposals in decision <i>'{group_name}'</i>.",
          "create": "created proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | created {group_notification_count} proposals in decision <i>'{group_name}'</i>. |_| created {group_notification_count} proposals in decision <i>'{group_name}'</i>.",
          "requested_changes": "requests changes for proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | requests changes for {group_notification_count} proposals in decision <i>'{group_name}'</i>. |_| requests changes for {group_notification_count} proposals in decision <i>'{group_name}'</i>."
        },
        "document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in directory <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in directory <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in directory <i>'{group_name}'</i>.",
          "employee_create": "uploaded document <i>'{notifiable_name}'</i> in directory <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in directory <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in directory <i>'{group_name}'</i>.",
          "proposal": {
            "create": "added document <i>'{notifiable_name}'</i> to proposal <i>'{group_name}'</i>. | added {group_notification_count} documents to proposal <i>'{group_name}'</i>. |_| added {group_notification_count} documents to proposal <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "received an inbound email <i>'{notifiable_name}'</i>. | received {group_notification_count} inbound emails. |_| received {group_notification_count} inbound emails."
          },
          "project": {
            "create": "received an inbound email <i>'{notifiable_name}'</i>. | received {group_notification_count} inbound emails. |_| received {group_notification_count} inbound emails."
          }
        },
        "export": {
          "create": "Your export data is ready to be downloaded."
        },
        "issue": {
          "approved": "approved snag <i>'{notifiable_name}'</i> for unit <i>'{level_name}'</i>. | approved {group_notification_count} snags'</i>. |_| approved {group_notification_count} snags.",
          "create": "created a new snag for unit <i>{level_name}</i> | created {group_notification_count} new snags for <i>{level_name}</i> |_| created {group_notification_count} new snags for <i>{level_name}</i>",
          "mention": {
            "create": "mentioned you in conversation <i>'{group_name}'</i>. | mentioned you in {group_notification_count} messages in conversation <i>'{group_name}'</i>. |_| mentioned you in {group_notification_count} messages in conversation <i>'{group_name}'</i>."
          },
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>."
          },
          "rejected": "rejected snag <i>'{notifiable_name}'</i> for unit <i>'{level_name}'</i>. | rejected {group_notification_count} snags'</i>. |_| rejected {group_notification_count} snags."
        },
        "issue_list": {
          "responsible": {
            "update": "made you the new responsible for snagging list <i>'{notifiable_name}'</i>."
          }
        },
        "question": {
          "create": "created question <i>'{notifiable_name}'</i> in FAQ <i>'{group_name}'</i>. | created {group_notification_count} questions in FAQ <i>'{group_name}'</i>. |_| created {group_notification_count} questions in FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "answered <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "completed": "completed <i>'{notifiable_name}'</i>.",
          "confirmation": {
            "requested": "asked you to confirm <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "asked you to upload a document for <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "started conversation <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "mentioned you in conversation <i>'{group_name}'</i>. | mentioned you in {group_notification_count} messages in conversation <i>'{group_name}'</i>. |_| mentioned you in {group_notification_count} messages in conversation <i>'{group_name}'</i>."
          },
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>."
          },
          "responsible": {
            "bulk_update": "transferred responsibility of conversations in project <i>'{project_name}'</i> from <i>{responsible_old_name}</i> to you.",
            "update": "assigned conversation <i>'{notifiable_name}'</i> to you."
          }
        },
        "ticket_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in conversation <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "assigned task <i>'{notifiable_name}'</i> to you in list <i>'{group_name}'</i>. | assigned {group_notification_count} tasks to you in list <i>'{group_name}'</i>. | assigned task <i>'{notifiable_name}'</i> to you in list <i>'{group_name}'</i>. | assigned {group_notification_count} tasks to you in list <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "All projects",
        "allDecisions": "All decisions",
        "allStatuses": "All",
        "compactView": "Compact view",
        "expandedView": "Expanded view",
        "filter": "Filter",
        "hideDecisionFilter": "Hide decision filter",
        "hideExtraFilters": "Hide extra filters",
        "noNewNotification": "You’re all caught up!",
        "noResults": "No results. Try something else!",
        "none": "You currently do not have any notifications.",
        "notification_level_name_asc": "Unit A->Z",
        "notification_level_name_desc": "Unit Z->A",
        "pinSidebar": "Pin sidebar",
        "showDecisionFilter": "Show decision filter",
        "showExtraFilters": "Show extra filters",
        "sort": "Sort by",
        "status": "Status",
        "unpinSidebar": "Unpin sidebar",
        "unreadOnly": "Unread only",
        "updated_at_asc": "Oldest first",
        "updated_at_desc": "Newest first"
      },
      "other_user": "and 1 other",
      "other_users": "and 1 other | and {count} others",
      "partners": {
        "decision": {
          "message": {
            "create": "sent a new message in conversation <i>'{group_name}'</i>. | sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>. |_| sent {group_notification_count} new messages in conversation <i>'{group_name}'</i>."
          },
          "not_interested": "is not interested in decision <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "started decision <i>'{notifiable_name}'</i>. | started {group_notification_count} <i>'{group_name}'</i> decisions. |_| started {group_notification_count} <i>'{group_name}'</i> decisions."
          }
        },
        "decision_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in decision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "approved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | approved proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | approved a proposal in decision <i>'{group_name}'</i>. | approved proposals in decision <i>'{group_name}'</i>.",
          "create": "created proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | created {group_notification_count} proposals in decision <i>'{group_name}'</i>. |_| created {group_notification_count} proposals in decision <i>'{group_name}'</i>.",
          "requested_changes": "requests changes for proposal <i>'{notifiable_name}'</i> in decision <i>'{group_name}'</i>. | requests changes for {group_notification_count} proposals in decision <i>'{group_name}'</i>. |_| requests changes for {group_notification_count} proposals in decision <i>'{group_name}'</i>."
        },
        "document": {
          "create": "shared document <i>'{notifiable_name}'</i> with you. | shared {group_notification_count} documents with you. |_| shared {group_notification_count} documents with you.",
          "proposal": {
            "create": "added document <i>'{notifiable_name}'</i> to proposal <i>'{group_name}'</i>. | added {group_notification_count} documents to proposal <i>'{group_name}'</i>. |_| added {group_notification_count} documents to proposal <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Your export data is ready to be downloaded."
        },
        "issue": {
          "status": {
            "update": "updated the status of a snag in <i>'{group_name}'</i>. | updated the status of {group_notification_count} snags in <i>'{group_name}'</i>. |_| updated the status of {group_notification_count} snags in <i>'{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "published an snagging list <i>'{notifiable_name}'</i> | published the snagging list <i>'{notifiable_name}'</i> for {group_notification_count} units |_| published the snagging list <i>'{notifiable_name}'</i> for {group_notification_count} units"
        },
        "reminder": {
          "due": "<i>'{notifiable_name}'</i> has not been decided for unit {level_name}."
        },
        "ticket_document": {
          "create": "uploaded document <i>'{notifiable_name}'</i> in conversation <i>'{group_name}'</i>. | uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>. |_| uploaded {group_notification_count} documents in conversation <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "has added customer <i>'{customer_group_name}'</i> to <i>'{group_name}'</i> for unit <i>'{notifiable_name}'</i>."
        }
      },
      "title": "Notifications"
    }
  }
}
